import { request, commonRequest } from '@/utils/request'
import type {
  ILoginProps,
  ISignupParams,
  IVerificationCodeParams,
} from '@/types'

// 登录
export const login = (payload: ILoginProps) => {
  return request.post('/login_by_phone', {
    ...payload,
  })
}

export const getVerificationCode = (payload: IVerificationCodeParams) => {
  return request.post('/send_code', {
    ...payload,
  })
}

export const signup = (payload: ISignupParams) => {
  return request.post('/register_by_phone', {
    ...payload,
  })
}

export const logout = () => {
  return request.post('/logout')
}

// 重置密码
export const resetPassword = (payload: {
  phoneNumber: string
  sms_code: string
  new_password: string
  confirm_pwd: string
}) => {
  return request.post('/resetpwd', {
    ...payload,
  })
}

export const uploadFile = (payload: any) => {
  return commonRequest.post('/storage/upload/simple', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
